import { UserContext } from "../../Core/SecurityContext";

declare const rootUrl: string;

export const GetUserContext = async (discoveryDocumentUrl: string): Promise<UserContext> => {
    return await fetch(discoveryDocumentUrl,
        {
            method: "GET",
        }).then(response => response.json())
        .then((json: any) => ({
            ProfileEditUrl: json.profile_edit,
            PasswordResetUrl: json.password_reset
        }));
}

